/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export const CONTAINER_STRINGS = {
  caption: 'Quarantined container images',
  list: {
    loading: 'Loading quarantined container images...',
    loadErrorTitle: 'Could not load quarantined container images',
    retry: 'Retry',
    emptyTitle: 'No quarantined container images',
    emptyDescription: 'Container images blocked by Firewall in this instance will appear here.',
    noResults: 'No results',
  },
  columns: {
    image: 'Image',
    tag: 'Tag',
    digest: 'Digest',
    policy: 'Policy Name',
    quarantineTime: 'Quarantine Time',
    repository: 'Repository',
    severity: 'Severity',
  },
  row: {
    unknownImage: 'Unknown image',
  },
  errors: {
    loadList: 'Failed to load quarantined container images.',
    notAvailable: 'Container images are not available yet.',
  },
  results: (total: string) => `${total} results`,
};
